import React, { useState, useCallback } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import Button from '../Button/Button';

import styles from './CopyButton.module.css';

const CopyButton = ({ value, disabled = false }) => {
    const [showCopied, setShowCopied] = useState(false);

    const onCopy = useCallback(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
    }, []);

    let copyButtonContent;
    if (showCopied) {
        copyButtonContent = <span>Copied!</span>;
    } else {
        copyButtonContent = (
            <>
                <i className="fa fa-copy" />
                <span className={styles.copyButtonText}>Copy</span>
            </>
        );
    }

    return (
        <CopyToClipboard text={value} onCopy={onCopy}>
            <Button disabled={disabled || !value || showCopied}>{copyButtonContent}</Button>
        </CopyToClipboard>
    );
};

export default React.memo(CopyButton);
